import LoginMethodButton from "./LoginMethodButton";

export default LoginMethodButton;
